export const TRANSLATION_KEYS = {
    Heading: "ticketDetailsPage.webchatDialog.heading",
    SecondaryHeading: "ticketDetailsPage.webchatDialog.secondaryHeading",
    ConfirmText: "common.continueText",
    DismissText: "common.dismissText"
};